import { render, staticRenderFns } from "./ResetGames.vue?vue&type=template&id=717768c6"
import script from "./ResetGames.vue?vue&type=script&lang=js"
export * from "./ResetGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports